import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Toaster } from 'components/core';
import FullLogo from 'assets/fullLogo.svg?react';
import { Color } from 'shared/utils/colors';
import { useLocation } from 'react-router-dom';
import { auth0Config } from '../../services/auth0/auth_config';
import { useAuth0 } from '../../services/auth0/react-auth0.spa';
import { useLoginPageStyles } from './styles';
import { frontendVersionWithBuildNumber } from 'shared/version';

const Login = (): JSX.Element => {
  const { handleRedirect } = useAuth0();
  const classes = useLoginPageStyles();
  const location = useLocation();
  const targetUrl = (location.state as { targetUrl?: string })?.targetUrl;

  const handleLoginRedirect = (): Promise<void> => {
    const redirect_uri = auth0Config.redirectAfterLoginUrl;
    return handleRedirect(redirect_uri, targetUrl);
  };

  return (
    <Box className={classes.container}>
      <Paper
        elevation={3}
        sx={{
          width: '30%',
          maxWidth: '400px',
          minWidth: '200px',
          minHeight: '360px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <FullLogo
          style={{ marginTop: '48px', marginBottom: '32px' }}
          width='50%'
          fill='black'
        />

        <Divider sx={{ width: '100%' }} />
        <Button
          variant='contained'
          id='loginButton'
          onClick={handleLoginRedirect}
          sx={{ my: 4 }}
        >
          <Typography variant='button'>LOG IN</Typography>
        </Button>
        <Divider sx={{ width: '100%' }}>OR</Divider>
        <Button
          variant='outlined'
          href='https://calendly.com/hustro/30min'
          target='_blank'
          sx={{
            mt: 4,
            color: Color.black,
            borderColor: Color.black,
            borderWidth: '1px !important',
            borderRadius: '4px',
            '&:hover': {
              borderColor: Color.black,
              backgroundColor: Color.primaryOrangeHover,
            },
          }}
        >
          <Typography variant='button'>BOOK A DEMO</Typography>
        </Button>
      </Paper>
      <Box className={classes.footerContainer}>
        <Box className={classes.leftFooterSection}>
          <Box className={classes.leftFooterItem}>
            Version:
            {frontendVersionWithBuildNumber}
          </Box>
          <Box className={classes.leftFooterItem}>
            <a
              href='https://www.hustro.com/privacy-policy/'
              target='_blank'
              rel='noopener noreferrer'
              style={{ cursor: 'pointer', textDecoration: 'none' }}
            >
              Privacy policy
            </a>
          </Box>
          <Box className={classes.leftFooterItem}>
            <a
              href='https://www.hustro.com/'
              target='_blank'
              rel='noopener noreferrer'
              style={{ cursor: 'pointer', textDecoration: 'none' }}
            >
              About Hustro
            </a>
          </Box>
        </Box>
        <Box className={classes.rightFooterItem}>
          @ 2021 Hustro. All rights reserved.
        </Box>
      </Box>
      <Toaster />
    </Box>
  );
};

export default Login;
